import { Navigate, Route } from 'react-router-dom';

import { AboutPage } from '@/pages/AboutPage';
import { DataPrivacyPage } from '@/pages/DataPrivacyPage';
import { ImprintPage } from '@/pages/ImprintPage';
import { RoutingPage } from '@/pages/RoutingPage';
import { SentryRoutes } from '@/setup/sentry';

export function App() {
  return (
    <SentryRoutes>
      <Route element={<RoutingPage />} path="/" />
      <Route element={<AboutPage />} path="/ueber-das-projekt" />
      <Route element={<ImprintPage />} path="/impressum" />
      <Route element={<DataPrivacyPage />} path="/datenschutz" />

      <Route element={<Navigate replace to="/" />} path="*" />
    </SentryRoutes>
  );
}
